import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { AuthShell, AuthCard, AuthInput, AuthButton, AuthError, AuthSuccess } from '../components/AuthShell';

export function ForgotPasswordPage() {
  const nav = useNavigate();
  const { forgotPassword, confirmForgotPassword, loading, error, clearError } = useAuthStore();
  const [step, setStep] = useState<'request' | 'confirm'>('request');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [success, setSuccess] = useState<string | null>(null);

  const requestCode = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    const r = await forgotPassword(email.trim().toLowerCase());
    if (r.ok) {
      setSuccess('Check your email for a 6-digit code.');
      setStep('confirm');
    }
  };

  const reset = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    const r = await confirmForgotPassword(email.trim().toLowerCase(), code.trim(), newPassword);
    if (r.ok) {
      nav('/login', { state: { email } });
    }
  };

  return (
    <AuthShell>
      <AuthCard
        title={step === 'request' ? 'Reset your password' : 'Set a new password'}
        subtitle={step === 'request' ? 'We\'ll email you a code.' : 'Enter the code we sent and your new password.'}
      >
        {step === 'request' ? (
          <form onSubmit={requestCode} className="space-y-4">
            <AuthInput type="email" label="Email" value={email} onChange={setEmail} required autoFocus />
            {error && <AuthError message={error} />}
            <AuthButton type="submit" loading={loading}>Send code</AuthButton>
          </form>
        ) : (
          <form onSubmit={reset} className="space-y-4">
            {success && <AuthSuccess message={success} />}
            <AuthInput label="6-digit code" value={code} onChange={setCode} required autoFocus />
            <AuthInput type="password" label="New password" value={newPassword} onChange={setNewPassword}
                       autoComplete="new-password" required
                       placeholder="At least 10 chars, with upper/lower/number" />
            {error && <AuthError message={error} />}
            <AuthButton type="submit" loading={loading}>Reset password</AuthButton>
          </form>
        )}
        <p className="mt-5 text-center text-sm">
          <Link to="/login" className="text-slate-500 hover:underline">← Back to sign in</Link>
        </p>
      </AuthCard>
    </AuthShell>
  );
}
